import { Http, Headers } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
import { AppService } from "../app.service";
var QrCodeService = (function () {
    function QrCodeService(http, appService) {
        this.http = http;
        this.appService = appService;
        this.apiUrl = environment.apiUrl;
        this.jwt = appService.getJwt();
    }
    QrCodeService.prototype.getQrCodeList = function (filterParams) {
        var url = this.apiUrl + 'api/qrcode/list';
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        var body = JSON.stringify(filterParams);
        return this.http.post(url, body, { headers: headers })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    QrCodeService.prototype.generateQrCode = function (data) {
        var url = this.apiUrl + 'api/qrcode/generate';
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        var body = JSON.stringify(data);
        return this.http.post(url, body, { headers: headers })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    QrCodeService.prototype.deleteQrCode = function (data) {
        var url = this.apiUrl + 'api/qrcode/delete';
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        var body = JSON.stringify(data);
        return this.http.post(url, body, { headers: headers })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    QrCodeService.prototype.setUsedQrCode = function (data, status) {
        var url = this.apiUrl + 'api/qrcode/set-used/' + status;
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        var body = JSON.stringify(data);
        return this.http.post(url, data, { headers: headers })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    return QrCodeService;
}());
export { QrCodeService };



// WEBPACK FOOTER //
// /build/client-cms/src/app/qr-code/qr-code.service.ts.pre-build-optimizer.js